(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-catalog"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', event => {
if (!event.target.matches('[data-pb-sort]')) return;
const url = new URL(window.location.href);
url.searchParams.set('sort_by', event.target.value);
url.searchParams.delete('page');
window.location.assign(url.toString());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-header"]) return;
  try {
    
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.pb-header details[open]').forEach(detail => { detail.open = false; detail.querySelector('summary').focus(); });
});
document.addEventListener('click', event => {
  document.querySelectorAll('.pb-header details[open]').forEach(detail => {
    if (!detail.contains(event.target)) detail.open = false;
    if (event.target.closest('a') && detail.contains(event.target)) detail.open = false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-product-help"]) return;
  try {
    
document.addEventListener('submit',event=>{const form=event.target;if(!form.matches('[data-pb-estimator]'))return;event.preventDefault();if(!form.reportValidity())return;const metres=Number(form.elements.metres.value),waste=Number(form.elements.waste.value);if(!Number.isFinite(metres)||metres<=0||!Number.isFinite(waste)||waste<0||waste>100)return;const millimetres=Math.round(metres*1000);const count=Math.ceil(millimetres*(100+waste)/230000);form.querySelector('[data-pb-count]').textContent=String(count);form.querySelector('[data-pb-result]').hidden=false;});
document.addEventListener('input',event=>{const form=event.target.closest('[data-pb-estimator]');if(form)form.querySelector('[data-pb-result]').hidden=true;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-project-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
const link = event.target.closest('[data-pb-lightbox]');
if (link) {
const dialog = document.querySelector('.pb-lightbox');
if (!dialog || typeof dialog.showModal !== 'function') return;
event.preventDefault();
const img = dialog.querySelector('img');
img.src = link.href;
img.alt = link.querySelector('img').alt;
dialog.querySelector('.pb-lightbox-caption').textContent = link.closest('figure').querySelector('figcaption')?.textContent || '';
dialog.showModal();
}
if (event.target.closest('.pb-lightbox-close')) event.target.closest('dialog').close();
if (event.target.matches('.pb-lightbox')) event.target.close();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-shop-room"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pb-shop-room')) {
  customElements.define('pb-shop-room', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-room-trigger]');
        if (trigger && this.contains(trigger)) {
          const id = trigger.dataset.roomTrigger;
          const card = Array.from(this.querySelectorAll('[data-room-card]')).find(item => item.dataset.roomCard === id);
          if (!card) return;
          event.preventDefault();
          const wasOpen = !card.hidden;
          this.closeCards();
          if (!wasOpen) {
            card.hidden = false;
            this.activeTrigger = trigger;
            this.querySelectorAll('[data-room-trigger]').forEach(item => item.setAttribute('aria-expanded', String(item.dataset.roomTrigger === id)));
            card.querySelector('[data-room-close]')?.focus({preventScroll:true});
            if (matchMedia('(max-width:749px)').matches) card.scrollIntoView({block:'nearest', behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
          }
        } else if (event.target.closest('[data-room-close]')) {
          this.closeCards(true);
        }
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.activeTrigger) {event.preventDefault();this.closeCards(true);}
      }, options);
      document.addEventListener('click', event => {if (!this.contains(event.target)) this.closeCards();}, options);
    }
    closeCards(restoreFocus=false) {
      this.querySelectorAll('[data-room-card]').forEach(card => {card.hidden=true;});
      this.querySelectorAll('[data-room-trigger]').forEach(trigger => trigger.setAttribute('aria-expanded','false'));
      if (restoreFocus) this.activeTrigger?.focus({preventScroll:true});
      this.activeTrigger=null;
    }
    disconnectedCallback() {this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
